// LIBRARY IMPORTS
import { FC, useCallback, useContext, Fragment, useState, useMemo, useEffect } from "react";
import { Card, makeStyles, CardContent } from "@material-ui/core";
import { withRouter, RouteComponentProps } from "react-router-dom";

// LOCAL IMPORTS
import { TramitesGateway } from "gateways/tramites.gateway";
import { FilterDataContext } from "./filters/filter.data.context";
import { AlertsContext } from "contexts/alerts.context";
import { IReciboFlexible } from "gateways/recibo-flexibles.interfaces ";
import { ScreenType } from "../filters.form";
import ReciboDetail from "./recibo-flexible.detail";
import ReciboGrid from "./recibo-flexible.grid";
import IoC from "contexts/ioc.context";




// STYLES
import styles from '../../shared/tributos.styles';

const useStyles = makeStyles(styles);

interface IReciboCardProps {
    recibo: IReciboFlexible;
}

const ReciboCard: FC<IReciboCardProps & RouteComponentProps> = ({ history, ...props }) => {
    // PROPS
    const { recibo } = props;

    // HOOKS
    const classes = useStyles();

    // CONTEXT
    const filterData = useContext(FilterDataContext);

    // STATES
    const [openDetail, setOpenDetail] = useState(false);
 
    // MEMOS
    // const selected = useMemo(() => selection.selected.findIndex((x: IReciboFlexible) => x.id === recibo.id) >= 0, [selection, recibo]);


    // HANDLERS

    const handleOpenDetail = useCallback(() => setOpenDetail(true), []);
    const handleCloseDetail = useCallback(() => setOpenDetail(false), []);
    
    const onPay = () => {
       history.push('/cartero-virtual/pago-flexible/pago', { recibo });
    }

    // USE EFFECTS



    return (
        <Fragment>
            <Card
                className={[classes.mainButton, classes.recibo].join(' ')}
                onClick={handleOpenDetail}>
                <CardContent>
                    <ReciboGrid
                        recibo={recibo}
                        filterData={filterData}
                        moreInfo={handleOpenDetail}
                        onPay={onPay}
                    />
                </CardContent>
            </Card>

            <ReciboDetail
                onClose={handleCloseDetail}
                open={openDetail}
                recibo={recibo}
            />
        </Fragment>
    );
};


export default withRouter(ReciboCard);